export default __webpack_public_path__ + "static/media/onboarding_4.e6f897ab.png";